import styled from 'styled-components';

export const SearchWidgetLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  background-color:${props.theme.colors.goBrand.blue};
  margin-bottom:${props.theme.spacing.base};
  position:sticky;
  top:0;
  z-index:9;
`,
);

export const SearchWidgetInnerLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
  width:100%;
  max-width:120rem;
  background-color:${props.theme.colors.goBrand.blue};
  margin:0 auto;
  padding-top:${props.theme.spacing.base};
  padding-bottom:${props.theme.spacing.base};
  `,
);

export const InnerWrapperDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    width:100%;
    align-items: flex-end;
    `,
);

export const SourceDestinationOuterWrapperDiv = styled.div(
  props => `

    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 60%;
    padding-right:${props.theme.spacing.xlarge};
    position: relative;
    `,
);

export const DepartureOuterWrapperDiv = styled.div(
  props => `

  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 20%;
  padding-right:${props.theme.spacing.xxlarge};
  padding-left:${props.theme.spacing.large};
  position: relative;
  `,
);

export const UpdateWrapperDiv = styled.div(
  props => `

    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 20%;
    padding-left:${props.theme.spacing.xlarge};
    position: relative;

    `,
);

export const PayBtnWrapDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    justify-content: center;


  `,
);

export const PayTxtSpan = styled.span(
  props => `
      font-family:${props.theme.font.fontFamily};
      font-size:${props.theme.font.large};
      font-weight:bold;
  `,
);

export const SearchLabelStyle = styled.label(
  (props: ThemeProps<Theme>) => `
    color: white;
    padding-bottom: ${props.theme.spacing.xsmall};
    padding-left: ${props.theme.spacing.custom(2)};
    opacity:0.6;
    font-size:${props.theme.font.base};
    &.error {
      opacity: 1;
    }
    `,
);

export const SearchInputStyle = styled.input(
  (props: ThemeProps<Theme>) => `
    background-color: ${props.theme.colors.blue.deepBlue};
    color: white;
    border: none;
    font-size: ${props.theme.font.custom(16)};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;

    display: block;
    width:100%;
    height: 4.2rem;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.custom(
    12,
  )} ${props.theme.spacing.base};
    line-height: 1.3;
    border-radius: ${props.theme.misc.borderRadius.base};
    flex-direction: row;
    align-items: center;
    justify-conent: center;
    &::-webkit-input-placeholder{
    color: white;
    opacity: 0.5;
    ${SearchInputStyle}.font-size;
    ${SearchInputStyle}.font-family;
    ${SearchInputStyle}.font-weight;
    }
    &:focus{
    box-shadow: none;
    outline: none;
    }
    &.error {
      border: 2px solid white
    }
    `,
);

export const DepartureInputStyle = styled.input(
  (props: ThemeProps<Theme>) => `
      background-color: ${props.theme.colors.blue.deepBlue};
      color: white;
      border: none;
      font-size: ${props.theme.font.custom(16)};
      font-family: ${props.theme.font.fontFamily};
      font-weight: bold;

      display: block;
      width:17rem;
      height: 4.2rem;
      padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.custom(
    12,
  )} ${props.theme.spacing.base};
      line-height: 1.3;
      border-radius: ${props.theme.misc.borderRadius.base};
      flex-direction: row;
      align-items: center;
      justify-conent: center;
      &::-webkit-input-placeholder{
      color: white;
      opacity: 0.5;
      ${SearchInputStyle}.font-size;
      ${SearchInputStyle}.font-family;
      ${SearchInputStyle}.font-weight;
      }
      &:focus{
      box-shadow: none;
      outline: none;
      }
      `,
);

export const FromOuterWrapperDiv = styled.div(
  props => `

      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      width: 45%;
      position: relative;
      `,
);

export const IconOuterWrapperDiv = styled.div(
  props => `

    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 10%;
    position: relative;
    padding-right:${props.theme.spacing.base};
    padding-left:${props.theme.spacing.base};
    padding-top:${props.theme.spacing.xlarge};
    align-items: center;
    cursor:pointer;
    `,
);

export const CalendarBlockOuterWrapper = styled.div(
  props => `
    width: 37.5rem;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: ${props.isSearchWidget ? '6.5rem' : '8rem'};
    // left: 0;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: 1.2rem;
  `,
);
